// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__3jGeh","tab":"ProcedureTabs_tab__3IDTT"};